export enum ValidityDateType{
    ValidNow = 1,
    NotValidNow = 2,
    All = 3
}